import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Reports.css';
import axios from '../../api/apiClient';
import { token, domain } from '../Security';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import loadingSpinner from './../../assets/loading.gif';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function SelectLogs({ user, isHideSideMenu }) {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [companyId, setCompanyId] = useState(0);
  const [company, setCompany] = useState(null);
  const [classificationId, setClassificationId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [locationId, setLocationId] = useState(0);
  const [errorState, setErrorState] = useState(false);
  const [loading, setLoading] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  function base64ToUint8Array(base64String) {
    const byteCharacters = atob(base64String); // Decode Base64
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    return new Uint8Array(byteNumbers);
  }
  const writeFont7Black = ({ page, font, x, y, text }) => {
    page.drawText(text, {
      x: x,  // Adjust X position
      y: y,  // Adjust Y position
      size: 7,
      font: font,
      color: rgb(0, 0, 0), // Black text
    })
  }
  const writeFont8Black = ({ page, font, x, y, text }) => {
    page.drawText(text, {
      x: x,  // Adjust X position
      y: y,  // Adjust Y position
      size: 8,
      font: font,
      color: rgb(0, 0, 0), // Black text
    })
  }

  const modifyAndDownloadPDF = useCallback(async (data) => {
    if (data.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No records found");
      return;
    }

    setLoading(true);
    console.log(data)

    try {
      // Load the existing PDF template
      const pdfUrl = `${window.location.origin}/docs/Select_Logs.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const templatePdf = await PDFDocument.load(pdfBytes); // Load again for copying

      let page = pdfDoc.getPages()[0]; // Get first page
      const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const fontNormal = await pdfDoc.embedFont(StandardFonts.Helvetica);

      let pageCount = 1;

      writeFont7Black({ page, fontNormal, x: 385, y: 20, text: `Page ${pageCount}` });

      const _dateToday = new Date().toISOString().split("T")[0];

      //611 height

      // Embed Company Logo
      if (company?.logo) {
        const companyLogoBinary = base64ToUint8Array(company.logo);
        const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
        page.drawImage(companyLogo, { x: 20, y: 500, width: 200, height: 100 });
      }

      //generated date
      writeFont7Black({ page, font, x: 655, y: 570, text: `${_dateToday}` });

      //generated by
      writeFont7Black({ page, font, x: 655, y: 548, text: `${user.employeePersonalInformationFullName}` });

      const _dateFrom = dateFrom.split("T")[0];
      const _dateTo = dateTo.split("T")[0];

      writeFont8Black({ page, font, x: 338, y: 469, text: `${_dateFrom}` });
      writeFont8Black({ page, font, x: 450, y: 469, text: `${_dateTo}` });

      const startX_item_1 = 35;
      const startX_item_2 = 185;
      const startX_item_3 = 378;
      const startX_item_4 = 485;
      const startX_item_5 = 603;
      const startX_item_6 = 694;

      let startY = 400;
      const lineSpacing = 15;
      const minY = 50; // Prevents writing too low

      for (let index = 0; index < data.length; index++) {
        const item = data[index];

        if (startY - lineSpacing < minY) {
          pageCount += 1;

          // Add new template page when out of space
          const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
          page = pdfDoc.addPage(templatePage);
          startY = 400; // Reset Y position

          // Embed Company Logo
          if (company?.logo) {
            const companyLogoBinary = base64ToUint8Array(company.logo);
            const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
            page.drawImage(companyLogo, { x: 20, y: 500, width: 200, height: 100 });
          }

          //generated date
          writeFont7Black({ page, font, x: 655, y: 570, text: `${_dateToday}` });

          //generated by
          writeFont7Black({ page, font, x: 655, y: 548, text: `${user.employeePersonalInformationFullName}` });

          const _dateFrom = dateFrom.split("T")[0];
          const _dateTo = dateTo.split("T")[0];

          writeFont8Black({ page, font, x: 338, y: 469, text: `${_dateFrom}` });
          writeFont8Black({ page, font, x: 450, y: 469, text: `${_dateTo}` });

          writeFont7Black({ page, fontNormal, x: 385, y: 20, text: `Page ${pageCount}` });
        }

        let _date = "";
        let _timeIn = "";
        let _timeOut = "";

        if (item.date) {
          _date = item.date.split("T")[0]
        }
        if (item.timeIn) {
          let time = ConvertForTimeLocal(item.timeIn, "Time In");

          let timeParts;
          const timeSplit = time.split('T');
          if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
          } else {
            timeParts = [];
          }
          let hours = parseInt(timeParts[0], 10);
          const minutes = timeParts[1];

          // Convert 24-hour format to 12-hour format and determine AM or PM
          const amPm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

          _timeIn = `${hours}:${minutes} ${amPm}`;
        }
        if (item.timeOut) {

          let time = ConvertForTimeLocal(item.timeOut, "Time Out");

          let timeParts;
          const timeSplit = time.split('T');
          if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
          } else {
            timeParts = [];
          }
          let hours = parseInt(timeParts[0], 10);
          const minutes = timeParts[1];

          // Convert 24-hour format to 12-hour format and determine AM or PM
          const amPm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

          _timeOut = `${hours}:${minutes} ${amPm}`;
        }

        // Write employee data
        writeFont7Black({ page, fontNormal, x: startX_item_1, y: startY, text: `${item.employeePersonalInformationEmployeeId}` });
        writeFont7Black({ page, fontNormal, x: startX_item_2, y: startY, text: `${item.employeePersonalInformationFullName}` });
        writeFont7Black({ page, fontNormal, x: startX_item_3, y: startY, text: `${_date}` });
        writeFont7Black({ page, fontNormal, x: startX_item_4, y: startY, text: `${_timeIn}` });
        writeFont7Black({ page, fontNormal, x: startX_item_5, y: startY, text: `${_timeOut}` });
        writeFont7Black({ page, fontNormal, x: startX_item_6, y: startY, text: `${item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName}` });

        startY -= lineSpacing; // Move to next row
      }


      setShowRequestMessage(true);
      setIsSuccess(true);

      // Save and Download PDF
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `Select_Logs.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      setRequestMessage("Error processing PDF");
    }

    setLoading(false);
  }, [company, user, dateFrom, dateTo]);

  const fetchDataCompany = useCallback(async () => {
    const apiUrl = domain + `/api/Company/${companyId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      return response.data;
    } catch (error) {
      return null
    }
  }, [companyId]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/Reports/select-logs`;

    const data = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      employeePersonalInformationId: 0,
      locationId: locationId ?? 0,
      departmentId: departmentId ?? 0,
      classificationId: classificationId ?? 0,
    };

    try {
      setLoading(true);
      const response = await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      const _company = await fetchDataCompany();
      setCompany(_company)

      modifyAndDownloadPDF(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [modifyAndDownloadPDF, fetchDataCompany, classificationId, departmentId, locationId, dateFrom, dateTo]);

  const generate = () => {
    if (!dateFrom || !dateTo || !companyId
    ) {
      setErrorState(true);
      return;
    }
    setErrorState(false);
    fetchData();
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="ReportsInfo shadow-xl">
            <div className="reports-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Reports >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Select Logs"}</span>
              </div>
              <h3>Select Logs Report</h3>
            </div>
            <div className="reports-body">
              <div className="info-item-holder row" style={{ alignItems: "center", justifyContent: "normal" }}>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFrom} setDate={setDateFrom} />
                  </div>
                  <span style={{
                    visibility: !dateFrom && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateTo} setDate={setDateTo} />
                  </div>
                  <span style={{
                    visibility: !dateTo && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Company</div>
                  <div className="info-item-input">
                    <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany} />
                  </div>
                  <span style={{
                    visibility: !companyId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row" style={{ alignItems: "center", justifyContent: "normal" }}>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Classification</div>
                  <div className="info-item-input">
                    <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Department</div>
                  <div className="info-item-input">
                    <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Location</div>
                  <div className="info-item-input">
                    <LocationIdSelect locationId={locationId} setLocationId={setLocationId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div className="reports-footer">
              <div className="buttons row">
                <button id="resignedGenerate"
                  className="generate row"
                  onClick={generate}
                > GENERATE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}

function DateTimeInput({ date, setDate }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  return (
    <div>
      <input
        type="date"
        id={"datetime-"}
        name="datetime"
        value={date}
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
        }}
      />
    </div>
  );
}
function CompanyTypeSelect({ companyId, setCompanyId, setCompany }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);

    const selectedCompanyId = event.target.value; // Get the selected company ID
    setCompanyId(selectedCompanyId);
    const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

    if (selectedCompany) {
      setCompany(selectedCompany); // Set the full company object
    }
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Company/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [companyId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose company type</option>
        {data.map((companyId) => (
          SetCompanyType(companyId)
        ))}
      </select>
    </div>
  );
};
function SetCompanyType(company) {
  return (
    <option value={company.id}>{
      company.name}
    </option>
  )

}
function ClassificationIdSelect({ classificationId, setClassificationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose classification</option>
        {data.map((classificationId) => (
          SetClassificationId(classificationId)
        ))}
      </select>
    </div>
  );
};
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{
      classificationId.description}
    </option>
  )
}
function DepartmentIdSelect({ departmentId, setDepartmentId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setDepartmentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Department/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (departmentId !== "" && departmentId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [departmentId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose department</option>
        {data.map((departmentId) => (
          SetDepartmentId(departmentId)
        ))}
      </select>
    </div>
  );
};
function SetDepartmentId(departmentId) {
  return (
    <option value={departmentId.id}>{
      departmentId.description}
    </option>
  )
}
function LocationIdSelect({ locationId, setLocationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Location/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (locationId !== "" && locationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [locationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose location</option>
        {data.map((locationId) => (
          SetLocationId(locationId)
        ))}
      </select>
    </div>
  );
};
function SetLocationId(locationId) {
  return (
    <option value={locationId.id}>{
      locationId.description}
    </option>
  )

}
const ConvertForTimeLocal = (dateString, name) => {
  // console.log("timeString", dateString);

  if (!dateString) {
    console.log(`${name} is empty or invalid data`);
    return "";
  }

  // Split the date and time parts
  const [datePart, timePart] = dateString.split('T');

  if (!timePart) {
    console.log(`${name} does not have a valid time part`);
    return "";
  }

  // Parse the date part
  const [year, month, day] = datePart.split('-');

  // Parse the time part
  const [hour, minute, second] = timePart.split(':');
  let hour24 = parseInt(hour, 10);

  // Construct the Date object
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minute, 10), parseInt(second, 10));

  // Format the date string in the desired format
  const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

  return formattedDateString;
};

export default SelectLogs
